module.exports = __webpack_public_path__ + "img/hublot-ch-pix.208eb26e.jpg";